import { State } from "..";

export const getSystems = (state: State) => state.home.loadSystems.success;
export const getSystemsReqInfo = (state: State) => state.home.loadSystems;
export const getDefaultSystem = (state: State) =>
	state.home.loadSystems.success ? state.home.loadSystems.success[0] : null;
export const deleteSuccess = (state: State) => state.home.deleteSystem.success;
